import { Fragment } from "react";
import PageDependencies from "../../../Feature/PageDependencies";

const SimulationLogDataTable = (props)=>{
    const { 
        useState,
        dataExtension,
        ServerSideDataTable,
    } = PageDependencies();
    const debug = props.debug === undefined ? false : props.debug;
    const data = props.data;
    const setData = props.setData;
    const tableId = "SimulationLog_12e1212f-6b03-4a7a-a396-1099c0f59d66";
    const tableReload = props.tableReload;
    const extraPostModel = props.extraPostModel;
    const url = props.url;
    const [selectedIds, setSelectedIds] = useState([]);
    const columns =[
      { name: "projectName", text: "Project Name", width: "50%" },
      { name: "simulationType", text: "Simulation Type", width: "20%" },
      { name: "simulationTime", text: "Date", width: "20%" },
      { name: "chenathRunCount", text: "Chenath Run Count", width: "10%" },
    ];
    const contextMenu = {
      items: {
        purchase: {
          name: "Purchase SimulationLogs",
          icon: "",
          defaultAction: true,
          url: "/UserAssessor/SimulationLogs/Purchase",
          isNavOption: true
        },
      },callBack: (
        contextMenuCallBackKey,
        contextMenuCallBackElement,
        contextMenuCallBackTableRoadData,
        localtion
      ) => {
      },
    };

    return(<Fragment>
      {debug && <p>{JSON.stringify(dataExtension.getSelectedRowDataIds(data))}</p>}
      <ServerSideDataTable
        //allowSelect
        debug ={debug}
        id={tableId}
        location="UserSimulationLogs"
        data={data}
        setData={setData}
        reload={tableReload}
        columns={columns}
        dataSource={{ isAuth: true, url: url }}
        //contextMenu={contextMenu}
        extraPostModel={extraPostModel}
        setSelectedItemIds = {setSelectedIds}
        ></ServerSideDataTable>
    </Fragment>);
}
export default SimulationLogDataTable;